<partial-loading-indicator class="chart-container-loading" [isLoading]="!isChartReady">
    <div class="chart-container" [class.-ready]="isChartReady" id="{{chartId}}" #chartContainer></div>
</partial-loading-indicator>

<chart-security-input
    [chartContainer]="chartContainer"
    [chartReady$]="chartReady$"
    [chartInstance$]="chartInstance$">
</chart-security-input>

<ng-container #confirmModalAnchor></ng-container>
